import { useCallback, useEffect, useState } from "react";
import UserLogin from "./UserLogin";
import { getCurrentUser } from "../../utils/AccountService";
import { User } from "../../models/User";
import UserInformation from "./UserInformation";
import Cookies from "js-cookie";

export type AccountSettingsProps = {
    // Switch the color mode to either dark or light
    switchColorMode: (colorMode: string) => void;
    // Changes the language of the application
    changeLanguage: (newLanguage: string) => void;
    // Changes the default font size of the application
    changeFontSize: (newFontSize: number) => void;
}

const AccountSettings = (props: AccountSettingsProps) => {
    const [currentUser, setCurrentUser] = useState<User | null>(null);

    const loadCurrentUser = useCallback(() => {
        const token: string | undefined = Cookies.get('token');
        if(token) {
            getCurrentUser().then((response: User) => {
                if(response !== null) {
                    setCurrentUser(response);
                    props.switchColorMode(response.userSettings.colorMode);
                    props.changeLanguage(response.userSettings.language);
                    props.changeFontSize(response.userSettings.fontSize);
                } else {
                    setCurrentUser(null);
                }
            });
        } else {
            setCurrentUser(null);
        }
    }, [props, setCurrentUser]);

    useEffect(() => {
        loadCurrentUser();
    }, [loadCurrentUser]);

    return (
        <div>
            { currentUser === null ? <UserLogin onLoginSuccessful={loadCurrentUser} /> : <UserInformation currentUser={currentUser} onLogoutSuccessful={loadCurrentUser} switchColorMode={props.switchColorMode} changeLanguage={props.changeLanguage} changeFontSize={props.changeFontSize} /> }
        </div>
    );
}

export default AccountSettings;